import { Modal, message } from "antd";
import branch from "branch-sdk";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { ButtonCustom } from "../UI/ButtonCustom/ButtonCustom";
import InputCustom from "../UI/InputCustom/InputCustom";
import { handleCopy } from "../common/commonFunctions";
import { CONFIG } from "../common/constant";
import { encryption } from "../common/encryption";
import copy from "../images/Copy.svg";
import logo from "../images/Logo.png";
import { apiRequest } from "../services/apiService"; // Import the apiRequest function
import { setToken, setUser } from "./../redux/slices/userAuthSlice";
import "./PaymentMode.scss";
function PaymentMode() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isPageVisible, setIsPageVisible] = useState(false);
  const [email, setEmail] = useState("");
  const [address, setAddress] = useState(localStorage.getItem("fromAddress"));
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [orderId, setOrderId] = useState(localStorage.getItem("orderId")); // Get orderId from localStorage
  const [tokenAddress, setTokenAddress] = useState();
  const [countdown, setCountdown] = useState(
    localStorage.getItem("countdownStartTime")
  ); // 120 minutes in seconds
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const token = useSelector((state) => state?.user?.token);
  const userDetails = useSelector((state) => state?.user?.user); // Adj
  // consust according to your actual state
  // useEffect(() => {
  //   const verifySignature = async () => {
  //     const queryParams = new URLSearchParams(window.location.search);
  //     const signature = queryParams.get("signature");
  //     const signSignature = queryParams.get("signSignature");
  //     const network = queryParams.get("network");
  //     const crypto = queryParams.get("crypto");
  //     const amount = queryParams.get("amount");
  //     const amountInUsd = queryParams.get("fiatAmountInUsd");

  //     const url = queryParams.get("redirectUrl");

  //     if (
  //       signature &&
  //       network &&
  //       amount &&
  //       signSignature &&
  //       url &&
  //       amountInUsd
  //     ) {
  //       const payload = {
  //         signature: signature,
  //         signSignature: signSignature,
  //         amount,
  //         network,
  //         crypto,
  //         redirectUrl: url,
  //         fiatAmountInUsd: amountInUsd,
  //       };
  //       console.log("PAYLOAD", payload);
  //       try {
  //         const data = await apiRequest(
  //           `${CONFIG?.API_URL}payment/verifySignature`,
  //           "POST",
  //           payload
  //         );
  //         if (data.status) {
  //           dispatch(setUser(data?.data));
  //           dispatch(setToken(data?.token));
  //           setTokenAddress(data?.token_address);
  //           setAddress(data?.from_address);
  //           setOrderId(data?.pay_order_id);
  //           setCountdown(data?.timestamp);
  //           localStorage.setItem("countdownStartTime", data?.timestamp);
  //           const newCountdown = Math.max(
  //             1200 - (Math.floor(Date.now() / 1000) - data.timestamp),
  //             0
  //           );
  //           setCountdown(newCountdown);
  //           if (data?.blockchain_status === "processing") {
  //             navigate(
  //               `/checkPaymentStatus?sessionId=${encodeURIComponent(
  //                 data?.token
  //               )}&orderId=${data?.pay_order_id}&fromAddress=${
  //                 data?.from_address
  //               }&timeStamp=${data?.timestamp}`
  //             );
  //           }
  //           // else if (data?.blockchain_status === "failed") {
  //           //   navigate("/transaction-failed", { state: data?.data });
  //           // }

  //           if (data?.pay_order_id != null && data?.from_address != null) {
  //             localStorage.setItem("orderId", data?.pay_order_id);
  //             localStorage.setItem("fromAddress", data?.from_address);

  //             setIsPageVisible(true);
  //           } else {
  //             localStorage.clear();
  //             setAddress("");
  //             setIsModalOpen(true);
  //           }
  //         } else {
  //           // message.error("Invalid API key or request parameters");
  //           setIsPageVisible(false);
  //           navigate("/unauthorized");
  //         }
  //       } catch (error) {
  //         const statusCode = localStorage.getItem("statusCode");
  //         if (statusCode == 503) {
  //           localStorage.setItem("redirectUrl", url);
  //           setIsPageVisible(false);
  //           navigate("/under-maintenance");
  //         } else {
  //           // message.error("An error occurred. Please try again.");
  //           setIsPageVisible(false);
  //           navigate("/unauthorized");
  //         }
  //       }
  //     } else {
  //       // message.error("Missing required query parameters");
  //       setIsPageVisible(false);
  //       navigate("/unauthorized");
  //     }
  //   };

  //   verifySignature();
  // }, []);
useEffect(() => {
  const verifySignature = async () => {
    const queryParams = new URLSearchParams(window.location.search);
    const signature = queryParams.get("signature");
    const signSignature = queryParams.get("signSignature");
    const network = queryParams.get("network");
    const crypto = queryParams.get("crypto");
    const amount = queryParams.get("amount");
    const amountInUsd = queryParams.get("fiatAmountInUsd");
    const url = queryParams.get("redirectUrl");

    if (signature && network && amount && signSignature && url && amountInUsd) {
      const payload = {
        signature: signature,
        signSignature: signSignature,
        amount,
        network,
        crypto,
        redirectUrl: url,
        fiatAmountInUsd: amountInUsd,
      };
      try {
        // ✅ FIX: Remove token parameter for verifySignature call
        const data = await apiRequest(
          `${CONFIG?.API_URL}payment/verifySignature`,
          "POST",
          payload
        );
        
        if (data.status) {
          dispatch(setUser(data?.data));
          dispatch(setToken(data?.token));
          setTokenAddress(data?.token_address);
          setAddress(data?.from_address);
          setOrderId(data?.pay_order_id);
          setCountdown(data?.timestamp);
          localStorage.setItem("countdownStartTime", data?.timestamp);
          
          const newCountdown = Math.max(
            1200 - (Math.floor(Date.now() / 1000) - data.timestamp),
            0
          );
          setCountdown(newCountdown);
          
          if (data?.blockchain_status === "processing") {
            navigate(
              `/checkPaymentStatus?sessionId=${encodeURIComponent(
                data?.token
              )}&orderId=${data?.pay_order_id}&fromAddress=${
                data?.from_address
              }&timeStamp=${data?.timestamp}`
            );
          }

          if (data?.pay_order_id != null && data?.from_address != null) {
            localStorage.setItem("orderId", data?.pay_order_id);
            localStorage.setItem("fromAddress", data?.from_address);
            setIsPageVisible(true);
          } else {
            localStorage.clear();
            setAddress("");
            setIsModalOpen(true);
          }
        } else {
          setIsPageVisible(false);
          navigate("/unauthorized");
        }
      } catch (error) {
        const statusCode = localStorage.getItem("statusCode");
        if (statusCode == 503) {
          localStorage.setItem("redirectUrl", url);
          setIsPageVisible(false);
          navigate("/under-maintenance");
        } else {
          setIsPageVisible(false);
          navigate("/unauthorized");
        }
      }
    } else {
      setIsPageVisible(false);
      navigate("/unauthorized");
    }
  };

  verifySignature();
}, []);
  useEffect(() => {
    const savedStartTime = localStorage.getItem("countdownStartTime");
    if (savedStartTime && isPageVisible) {
      const now = Math.floor(Date.now() / 1000); // Convert current time to seconds
      const elapsedTime = now - parseInt(savedStartTime); // Calculate elapsed time in seconds
      const newCountdown = Math.max(1200 - elapsedTime, 0); // Ensure countdown doesn't go below 0
      setCountdown(newCountdown);
    }
  }, [isPageVisible]);

  const handleProceed = async () => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!email || !address) {
      message.error("Please fill out both email and wallet address fields.");
      return;
    }

    if (!emailRegex.test(email)) {
      message.error("Please enter a valid email address.");
      return;
    }

    setIsSubmitting(true);
    try {
      const payloadData = {
        fromAddress: address,
        email: email,
        amount: userDetails?.amount,
        network: userDetails?.network,
        crypto: userDetails?.crypto,
        fiatAmountInUsd: userDetails?.fiatAmountInUsd,
        // redirectUrl: userDetails?.redirect_url,
      };
      const enc = await encryption(JSON.stringify(payloadData));
      const securedData = { dataString: enc };
      const result = await apiRequest(
        `${CONFIG?.API_URL}payment/createOrder`,
        "POST",
        securedData,
        token
      );

      if (result.status) {
        message.success(result?.message);
        setOrderId(result?.data?.pay_order_id);
        localStorage.setItem("orderId", result?.data?.pay_order_id); // Save orderId to localStorage
        localStorage.setItem("fromAddress", result?.data?.from_address); // Save orderId to localStorage
        setIsModalOpen(false);
        setIsPageVisible(true);
      } else {
        message.error("Submission failed. Please try again.");
      }
    } catch (err) {
      if (err?.status === 401) {
        message.error("Session Expired!");
        navigate("/unauthorized");
      } else if (err?.message == "Invalid token address.") {
        message.error("Session Expired!");
        navigate("/unauthorized");
      } else {
        message.error(err?.message);
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  // const handleDeepLink = async () => {
  //   try {
  //     var linkData = {
  //       campaign: "content 123",
  //       channel: "triskel",
  //       feature: "payment",
  //       stage: "new user",
  //       tags: ["tag1", "tag2", "tag3"],
  //       alias: "",
  //       data: {
  //         toAddress: userDetails?.wallet_address,
  //         amount: userDetails?.amount,
  //         network:
  //           userDetails?.network?.toLowerCase() == "pol"
  //             ? "matic"
  //             : userDetails?.network,
  //         crypto:
  //           userDetails?.crypto?.toLowerCase() == "pol"
  //             ? "matic"
  //             : userDetails?.crypto,
  //         redirectUrl:
  //           "https://www.pay-gateway.triskel-cap.com/checkPaymentStatus",
  //         fiatAmountInUsd: userDetails?.fiatAmountInUsd,
  //         fromAddress: address,
  //         timeStamp: localStorage?.getItem("countdownStartTime"),
  //         orderId: orderId,
  //         sessionId: encodeURIComponent(token),
  //         tokenAddress: tokenAddress,
  //         $desktop_url: "https://www.triskel-wallet.com/",
  //         // $ios_url: "https://apps.apple.com/in/app/triskel-wallet/id6449494626",
  //         // $ipad_url:
  //         //   "https://apps.apple.com/in/app/triskel-wallet/id6449494626",
  //         // $android_url:
  //         //   "https://play.google.com/store/apps/details?id=com.triskel&hl=en",
  //       },
        
  //     };
  //     console.log(">>>>>>>>>>>>>>>>LINKDATA", linkData);
  //     // Return a promise for the deep link
  //     const deepLink = await new Promise((resolve, reject) => {
  //       console.log("Generating link with data:", deepLink);
  //       branch.link(linkData, function (err, link) {
  //         if (err) {
  //           console.error("Error generating link:", err);
  //           reject(err); // Reject the promise in case of error
  //         } else {
  //           console.log("Generated Link:", link);
  //           resolve(link); // Resolve the promise with the generated link
  //         }
  //       });
  //     });

  //     if (typeof deepLink === "string" && deepLink.length > 0) {
  //       const anchor = document.createElement("a");
  //       anchor.href = deepLink;
  //       anchor.target = "_blank";
  //       anchor.click();
  //     } else {
  //       throw new Error("Invalid deep link generated");
  //     }
  //   } catch (error) {
  //     console.error("Error creating deep link:", error);
  //     message.error("Failed to generate payment link. Please try again.");
  //   }
  // };
const handleDeepLink = async () => {
  try {
    // Validate required data before creating link
    if (!userDetails?.wallet_address || !userDetails?.amount) {
      throw new Error("Missing required user details");
    }

    // Check if Branch SDK is loaded
    if (!window.branch) {
      throw new Error("Branch SDK not initialized");
    }

    // Get timestamp from localStorage
    const countdownStartTime = localStorage?.getItem("countdownStartTime");
    

    const linkData = {
      campaign: "content 123",
      channel: "triskel",
      feature: "payment",
      stage: "new user",
      tags: ["tag1", "tag2", "tag3"],
      alias: "",
      data: {
        // Core payment data
        toAddress: userDetails?.wallet_address,
        amount: userDetails?.amount,
        network:
          userDetails?.network?.toLowerCase() === "pol"
            ? "matic"
            : userDetails?.network,
        crypto:
          userDetails?.crypto?.toLowerCase() === "pol"
            ? "matic"
            : userDetails?.crypto,
        
        // Additional payment info
        redirectUrl:
          "https://www.pay-gateway.triskel-cap.com/checkPaymentStatus",
        fiatAmountInUsd: userDetails?.fiatAmountInUsd,
        fromAddress: address,
        timeStamp: countdownStartTime || new Date().getTime().toString(),
        orderId: orderId,
        sessionId: encodeURIComponent(token),
        tokenAddress: tokenAddress,
        
        // Deep linking URLs - IMPORTANT: These must be uncommented for new users
        $desktop_url: "https://www.triskel-wallet.com/",
        $ios_url: "https://apps.apple.com/in/app/triskel-wallet/id6449494626",
        $ipad_url:
          "https://apps.apple.com/in/app/triskel-wallet/id6449494626",
        $android_url:
          "https://play.google.com/store/apps/details?id=com.triskel&hl=en",
      },
    };


    // Generate the deep link using Branch
    const deepLink = await new Promise((resolve, reject) => {
      branch.link(linkData, function (err, link) {
        if (err) {
          console.error("Error generating link:", err);
          reject(err);
        } else {
          resolve(link);
        }
      });
    });

    // Validate and open the deep link
    if (typeof deepLink === "string" && deepLink.length > 0) {      
      const anchor = document.createElement("a");
      anchor.href = deepLink;
      anchor.target = "_blank";
      anchor.rel = "noopener noreferrer";
      anchor.click();
      
      // Clean up
      setTimeout(() => {
        document.body.removeChild(anchor);
      }, 100);
    } else {
      throw new Error("Invalid deep link generated");
    }
  } catch (error) {
    console.error("Error creating deep link:", error);
    message.error("Failed to generate payment link. Please try again.");
  }
};
  const pollPaymentStatus = async () => {
    try {
      let payloadData = {
        payOrderId: orderId,
        fromAddress: address,
        status: "NO",
      };
      const enc = await encryption(JSON.stringify(payloadData));
      const securedData = { dataString: enc };
      const result = await apiRequest(
        `${CONFIG?.API_URL}payment/checkTransactionStatus`,
        "POST",
        securedData, // Use the relevant order ID
        token
      );
      if (result?.data?.blockchain_status === "confirmed") {
        message.success("Payment confirmed.");
        navigate("/payment-detail", { state: result?.data });
        setCountdown(0); // Stop the countdown when payment is confirmed
      } else if (result?.data?.blockchain_status === "failed") {
        message.error("Payment Failed.");
        navigate("/transaction-failed", { state: result?.data });
        setCountdown(0); // Stop the countdown when payment is confirmed
      } else if (result?.data?.blockchain_status === "processing") {
        navigate(
          `/checkPaymentStatus?sessionId=${encodeURIComponent(
            token
          )}&orderId=${orderId}&fromAddress=${address}&timeStamp=${localStorage?.getItem(
            "countdownStartTime"
          )}`
        );
      } else if (result?.status == "false") {
        navigate("/unauthorized");
      }
    } catch (error) {
      const errorMessage = error?.message || error?.toString(); // Safely get the error message
      if (errorMessage.includes("Invalid token address")) {
        navigate("/unauthorized");
      }

      console.error("Error checking payment status:", error);
    }
  };

  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${minutes}:${secs < 10 ? "0" : ""}${secs}`;
  };

  useEffect(() => {
    let interval;
    if (isPageVisible && countdown > 0) {
      interval = setInterval(() => {
        setCountdown((prevCountdown) => prevCountdown - 1);

        // Poll API every 5 seconds
        if (countdown % 5 === 0) {
          pollPaymentStatus();
        }
      }, 1000);
    }

    if (countdown === 0 && isPageVisible) {
      clearInterval(interval); // Stop the countdown when it reaches 0
      message.error("Payment session expired.");
      localStorage.clear();
      window.location.replace(userDetails?.redirect_url);
    }

    return () => clearInterval(interval); // Cleanup on unmount
  }, [isPageVisible, countdown]);

  useEffect(() => {
    if (isPageVisible) {
      pollPaymentStatus();
    }
  }, [isPageVisible]);

  return (
    <div className="paymentMode container">
      {isPageVisible ? (
        <>
          <div className="paymentMode_left commonBG">
            <h3>Scan and Pay</h3>
            <h4>
              {userDetails?.amount} {userDetails?.crypto} (
              {userDetails?.network})
            </h4>
            <div className="paymentMode_left_scanner">
              <img src={userDetails?.qr_code} alt="QR Code Scanner" />
            </div>
            <div className="paymentMode_left_copycode">
              <p>{userDetails?.wallet_address}</p>
              <span>
                <img
                  src={copy}
                  alt="Copy Icon"
                  onClick={() => {
                    handleCopy(userDetails?.wallet_address);
                  }}
                />
              </span>
            </div>
          </div>
          <div className="paymentMode_right commonBG">
            <div>
              <h3>
                <span>
                  <img src={logo} alt="Triskel Logo" />
                </span>
                Pay Via Triskel App
              </h3>
              <p>
                A payment link with order details will be sent to your email.
                <br />
                Pay through your Triskel app.
              </p>
              <ButtonCustom
                basicBtn
                label="Get Payment Link"
                onClick={handleDeepLink}
              />
            </div>
          </div>
          <div className="timer">
            <p>Time remaining: {formatTime(countdown)}</p>
          </div>
        </>
      ) : null}
      <Modal
        open={isModalOpen}
        className="detailModal"
        closable={false}
        centered
      >
        <h4>Enter User Details</h4>
        <InputCustom
          basicInput
          inputCustum
          label="Email ID"
          placeholder="Enter Email ID"
          maxLength={100}
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        <InputCustom
          basicInput
          inputCustum
          label="From Address"
          placeholder="Enter From Address"
          maxLength={100}
          value={address}
          onChange={(e) => setAddress(e.target.value.trim())}
        />
        <ButtonCustom
          basicBtn
          label="Proceed"
          onClick={handleProceed}
          disabled={isSubmitting}
        />
        <p
          style={{
            color: "red",
            display: "flex",
            justifyContent: "center",
            alignContent: "center",
          }}
        >
          You have to complete your transaction within 20 minutes!
        </p>
      </Modal>
    </div>
  );
}

export default PaymentMode;
